/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Col, Button } from "react-bootstrap";
import { BsPatchCheckFill } from "react-icons/bs";
import { FaBed, FaChild } from "react-icons/fa";
import { FaPerson } from "react-icons/fa6";
import CancellationModal from "./CancellationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useCheckRate from "hooks/hotel/useCheckRate";
import { formatPrice } from "helpers/common";

const getAllRates = (hotel) => {
    if(!hotel.rooms) {
        return [];
    }
    const hotelState = JSON.parse(localStorage.getItem("hotelState") || "{}");
    const rates = [];
    Object.keys(hotel?.rooms).forEach((room, i) => {
        hotel?.rooms[room]?.rates?.forEach((r) => {
            rates.push({
                name: hotel?.rooms[room]?.roomCombination[0]?.name ,
                pension: r.boardName,
                price: r.net.total,
                currency: r.net.currency,
                rateKey: r.rateKey,
                selected: false,
                persons: {
                    adults: hotelState.rooms[i]?.adults,
                    children: hotelState.rooms[i]?.children,
                },
                supplements: r?.supplements || [],
            });
        });
    });
    const sortedRates = rates.sort((a, b) => a.price - b.price);
    return sortedRates;
};

const CombinedRooms = ({ hotel, isLoading }) => {
    const allRates = getAllRates(hotel);
    const hotelState = JSON.parse(localStorage.getItem("hotelState") || "{}");
    const rooms = hotelState.rooms;
    let boards = [
        "All",
        ...allRates.map((rate) => {
            return `${rate.pension}`;
        }),
    ];
    // remove duplicates
    boards = [...new Set(boards.map((board) => board.split("|")[0]))];

    const { t } = useTranslation();
    const [filteredRates, setFilteredRates] = useState(allRates);
    const [selectedBoards, setSelectedBoards] = useState(["All"]);
    const { goToDetailsCombined } = useCheckRate(hotel);
    useEffect(() => {
        if (selectedBoards.includes("All")) {
            setFilteredRates(allRates);
        } else {
            setFilteredRates(
                allRates.filter((rate) => selectedBoards.includes(rate.pension))
            );
        }
    }, [selectedBoards, hotel]);

    const handleBoardChange = (board) => {
        if (selectedBoards.includes(board) && selectedBoards.length === 1)
            return;
        setSelectedBoards((prev) => {
            if (board === "All") {
                return prev.includes("All") ? [] : ["All"];
            }
            if (prev.includes(board)) {
                return prev.filter((b) => b !== board);
            }
            return prev.filter((b) => b !== "All").concat(board);
        });
    };

    return (
        <div className="">
            {isLoading && (
                <div
                    className="w-100 d-flex justify-content-center align-items-center"
                    style={{ height: "60dvh" }}
                >
                    <l-square
                        size="40"
                        stroke="3.5"
                        speed="1"
                        color="black"
                    ></l-square>
                </div>
            )}
            {!isLoading && filteredRates.length === 0 && (
                <div className="text-center mt-5">
                    <h4 className="text-secondary-color">
                        {t("noRatesFound")}
                    </h4>
                </div>
            )}

            {!isLoading && filteredRates.length > 0 && (
                <>
                    <Card className="card-body  p-2 room mt-2 rounded-md">
                        <div className="d-flex gap-2 mb-0 g-3 ">
                            {boards?.map((board, idx) => (
                                <div key={idx} className="  mb-0">
                                    <input
                                        type="checkbox"
                                        className="btn-check"
                                        id={`btn-check-${idx}`}
                                        checked={selectedBoards.includes(board)}
                                        onChange={() =>
                                            handleBoardChange(board)
                                        }
                                    />
                                    <label
                                        className={`btn btn-sm  hover:text-black ${
                                            selectedBoards.includes(board)
                                                ? " bg-hover-color text-main-color"
                                                : ""
                                        } btn-primary-soft-check`}
                                        htmlFor={`btn-check-${idx}`}
                                    >
                                        { t(board.toLowerCase()) }
                                    </label>
                                </div>
                            ))}
                        </div>
                    </Card>
                    <div className="">
                        {filteredRates.map((rate, idx) => {
                            return (
                                <Card
                                    key={idx}
                                    className="card-body room  p-3 mt-2 rounded-md"
                                >
                                    <Col>
                                        <div className="d-flex flex-column  flex-md-row justify-content-md-between  align-items-center justify-content-center">
                                            <div className="fw-bold text-md-start text-truncate">
                                                {rate.name}
                                            </div>
                                            <div
                                                onClick={() => {
                                                    console.log(hotel)
                                                } }
                                                dir="ltr"
                                                className="d-flex gap-2 text-main-color p-0 align-items-center text-truncate"
                                            >
                                                <BsPatchCheckFill className="" />
                                                {rate.pension}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col className="d-flex flex-column  flex-md-row justify-content-md-between  align-items-center justify-content-center my-3">
                                        <div className="text-center text-md-start">
                                            {rooms?.map((room, idx) => {
                                                return (
                                                    <div
                                                        key={idx}
                                                        className="d-flex align-items-center gap-2 mb-1"
                                                    >
                                                        <span className="fw-bold">
                                                            <FaBed className=" " />
                                                        </span>
                                                        <span className="d-flex gap-2 align-items-center">
                                                            <FaPerson className="" />{" "}
                                                            {room.adults}{" "}
                                                            {room.adults === 1
                                                                ? t("adult")
                                                                : t("adults")}
                                                        </span>
                                                        {room.children > 0 && (
                                                            <span className="d-flex gap-2  align-items-center  ">
                                                                <FaChild className=" " />{" "}
                                                                {room.children}{" "}
                                                                {room.children ===
                                                                1
                                                                    ? t("child")
                                                                    : t(
                                                                          "children"
                                                                      )}
                                                            </span>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <CancellationModal
                                            key={idx}
                                            rate={rate}
                                            hotel={hotel}
                                        />
                                    </Col>
                                    <Col>
                                        <div className="d-flex justify-content-between align-items-center gap-4">
                                            <div className="d-flex gap-2 fw-bold text-price ">
                                                {formatPrice(
                                                    rate.price
                                                ).replace("DA", t("DA"))}
                                            </div>
                                            <Button
                                                onClick={() => {
                                                    rate.selected = true;
                                                    goToDetailsCombined(rate);
                                                }}
                                                className="btn bg-hover-color text-main-color rounded-md px-4 py-2 font-semibold border border-main-color hover:bg-main-color hover:text-white"
                                            >
                                                {t("bookNow")}
                                            </Button>
                                        </div>
                                    </Col>
                                </Card>
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
};

export default CombinedRooms;
